/**
 * @file Homepage Featured Cs.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Featured Cs component.
 */
const vHpFeaturedCs = () => {
	const hpFeaturedCs = document.querySelector('.v-hp-featured-cs');

	if (!hpFeaturedCs) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const cases = hpFeaturedCs.querySelectorAll('.v-hp-featured-cs__case');
	const floatingCta = hpFeaturedCs.querySelector('.v-hp-featured-cs__floating-cta');
	const mm = gsap.matchMedia();
	const ctaTween = gsap.to(floatingCta, {
		opacity: 1,
		y: 0,
		paused: true,
		ease: 'power4.inOut',
		duration: 0.5,
		onComplete: () => {
			floatingCta.classList.add('v-hp-featured-cs__floating-cta--stuck');
			gsap.set(floatingCta, { clearProps: 'all' });
		},
		onReverseComplete: () => {
			floatingCta.classList.remove('v-hp-featured-cs__floating-cta--stuck');
			gsap.set(floatingCta, { clearProps: 'all' });
		}
	});

	/**
	 * Reveal the CTA.
	 */
	const revealCta = () => {
		ctaTween.play();
	};

	/**
	 * Hide the CTA.
	 */
	const hideCta = () => {
		ctaTween.reverse();
	};

	[...cases].forEach((caseItem) => {
		const img = caseItem.querySelector('.v-hp-featured-cs__img');
		const content = caseItem.querySelector('.v-hp-featured-cs__content-inner');

		mm.add({
			isLaptop: '(min-width: 860px) and (max-width: 1440px)',
			isDesktop: '(min-width: 1440px)',
		},
			(ctx) => {
				const { isLaptop, isDesktop } = ctx.conditions;

				if (!isLaptop && !isDesktop) {
					return;
				}

				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: caseItem,
						start: 'top bottom',
						end: 'center center',
						toggleActions: 'play none none reverse',
						scrub: true,
					},
				});

				tl.from(img, {
					yPercent: isLaptop ? 20 : 30,
				})
				.from(content, {
					yPercent: isLaptop ? 70 : 72,
				}, '<');
			}
		);
	});

	ScrollTrigger.create({
		trigger: hpFeaturedCs,
		start: 'top center',
		end: 'bottom bottom',
		onEnter: revealCta,
		onLeave: hideCta,
		onEnterBack: revealCta,
		onLeaveBack: hideCta,
	});
};

export default vHpFeaturedCs;
